import React from "react";
import moment from "moment";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { bindActionCreators } from "redux";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import SnackbarClose from "components/SnackbarClose";
import theme from "config/theme";
import setupStore from "config/store";
import { MAX_SNACK, SNACKBAR_ORIGIN } from "config/constants";
import setupAxiosInterceptors from "config/axios-interceptor";
import { clearAuthentication } from "shared/reducer/authentication";
import App from "App";
import "./i18n";
import "moment/locale/hu";

moment.locale("hu");

const store = setupStore();
const actions = bindActionCreators({ clearAuthentication }, store.dispatch);

setupAxiosInterceptors(() => actions.clearAuthentication);

const Loading = () => (
	<div>
		<div>loading...</div>
	</div>
);

const Root = () => {
	return (
		<BrowserRouter basename="/">
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<SnackbarProvider
						maxSnack={MAX_SNACK}
						anchorOrigin={SNACKBAR_ORIGIN}
						action={key => <SnackbarClose itemKey={key} />}
					>
						<React.Suspense fallback={<Loading />}>
							<App />
						</React.Suspense>
					</SnackbarProvider>
				</ThemeProvider>
			</Provider>
		</BrowserRouter>
	);
};

ReactDOM.render(<Root />, document.getElementById("root"));
